import { createAsyncReducer } from '@telstra-connect/standard-actions/';
import {
    IDownloadAttachmentAction,
    IDownloadAttachmentSuccessAction,
    IDownloadAttachmentErrorAction
} from '../actions/download-attachment';
import { IServiceRequestsState } from '../state';
import { initialState } from '@telstra-connect/service-requests/state/initial-state';

export type DownloadAttachmentAction
    = IDownloadAttachmentAction
    | IDownloadAttachmentSuccessAction
    | IDownloadAttachmentErrorAction;

const init = (state: IServiceRequestsState, action: DownloadAttachmentAction) => ({
    ...state,
    downloadAttachment: {
        ...initialState.downloadAttachment,
        status: action.status
    }
});

const success = (state: IServiceRequestsState, action: DownloadAttachmentAction) => ({
    ...state,
    downloadAttachment: {
        status: action.status
    }
});

const failure = (state: IServiceRequestsState, action: DownloadAttachmentAction) => ({
    ...state,
    downloadAttachment: {
        status: action.status,
        error: (action as IDownloadAttachmentErrorAction).error,
        code: (action as IDownloadAttachmentErrorAction).code
    }
});

export const downloadAttachmentReducer = createAsyncReducer(initialState, init, success, failure);
